module.exports = __webpack_public_path__ + "static/media/HCMM220.9cab7fc8.jpg";